export default {
  install (Vue) {
    Vue.mixin({
      directives: {
        'click-outside': {
          bind (el, binding, vNode) {
            if (typeof binding.value !== 'function') {
              const handler = (event) => {
                if (!el.contains(event.target) && el !== event.target) {
                  vNode.context[binding.expression] = null
                }
              }
              document.addEventListener('click', handler)
            }
          },
          unbind (el) {
            document.removeEventListener('click', el.handler)
          }
        }
      }
    })
  }
}
